import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Resource } from '@/types/user';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getResources = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<Resource[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<Resource[]>>('/organization/resource', options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
